import { useLocation } from "react-router-dom";
import { Locale, splitLocale } from "../seo/locales";

/**
 * Current locale and the path with its locale prefix removed.
 *
 * `basePath` is the key used by src/seo/pages.json — the JSON is indexed by the
 * untranslated path, with the locale as the outer key.
 */
export function useLocale(): { locale: Locale; basePath: string; pathname: string } {
    const { pathname } = useLocation();
    const { locale, basePath } = splitLocale(pathname);
    return { locale, basePath, pathname };
}
